import classnames from 'classnames';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

export type PoiHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function PoiHeader({
  style,
  isOpen,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: PoiHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        {isOpen ? (
          <i className="fas fa-chevron-down" />
        ) : (
          <i className="fas fa-chevron-down fa-rotate-270" />
        )}
        &nbsp;
        <div className="starter-list-header-item-label">{t('list.POI')}</div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
